export const backendUrls = {
   getFilteredVideos:"GetFilteredVideos",
   getCompanyById:"GetCompanyById"  
  };